import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, fonts, fontSize } = redesignTheme;

export const useLoginFormStyles = makeStyles(() => ({
  linkRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  link: {
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.sm,
    color: colors.link,
    textDecoration: 'underline',
    lineHeight: 1.4,
  },
}));
